import React, { useState } from 'react';
import CharCount from '../../../charCount/CharCount';
import styles from './activityPrice.module.css';
import RadioButtons from '../../../radiobutton/RadioButtons';
import GuidInstallments from '../../../Guid/orgGuidPackUploadSection/guidInstallments/GuidInstallments';
import ActivityMeetup from '../actMeetup/ActivityMeetup';

const ActivityPrice = ({ activityData, setActivityData }) => {
    const [priceCount, setPriceCount] = useState(1);

    const handlePrice = (event, priceIndex) => {
        const { name, value } = event.target;

        setActivityData((prev) => {
            const updatedPriceArray = prev.price.map((priceItem, index) => {
                if (index !== priceIndex) return priceItem;

                let updatedFieldValue = value;
                if (['actual', 'reserve', 'higherPrice', 'discountPer'].includes(name)) {
                    updatedFieldValue = Math.round(value);
                }

                const actualValue = name === 'actual' ? Math.round(value) : priceItem.actual || 0;

                const calculatedTax = name === 'actual' ? Math.round(actualValue * 0.05) : priceItem.tax;

                const calculatedTotal = name === 'actual' ? actualValue + calculatedTax : priceItem.total;

                return {
                    ...priceItem,
                    [name]: updatedFieldValue,
                    tax: calculatedTax,
                    total: calculatedTotal
                };
            });

            return {
                ...prev,
                price: updatedPriceArray
            };
        });
    };

    const handleAddPrice = () => {
        setActivityData((prev) => ({
            ...prev,
            price: [
                ...(prev.price || []),
                {
                    actual: null,
                    tax: null,
                    total: null,
                    reserve: null,
                    higherPrice: null,
                    discountPer: null,
                    name: '',
                    count: 1,
                    terms: [],
                    instalments: [
                        {
                            percentage: null,
                            comment: '',
                            amount: null,
                            trigger: null
                        }
                    ]
                }
            ]
        }));
        setPriceCount((prev) => prev + 1);
    };

    const handleDeletePrice = () => {
        setActivityData((prev) => {
            if (priceCount > 1) {
                const updatedPriceArray = [...prev.price];
                updatedPriceArray.pop();
                return {
                    ...prev,
                    price: updatedPriceArray
                };
            }
        });
        setPriceCount((prev) => prev - 1);
    };

    return (
        <div>
            <h2 className={styles.orgPackUpH2}>Price</h2>
            <div className={styles.orgPackUpSecDiv}>
                {priceCount > 0 &&
                    Array.from({ length: priceCount }).map((_, priceindex) => (
                        <div key={priceindex}>
                            <p className={styles.priceLabel}>Activity {priceindex + 1}</p>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Actual Price</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.actual || null}
                                        type='number'
                                        name='actual'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`Actual Price for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]
                                                ? String(activityData.price[priceindex].actual)
                                                : ''
                                        }
                                        min={2}
                                        limit={7}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Tax</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.tax ?? 0}
                                        type='number'
                                        name='tax'
                                        readOnly
                                        placeholder={`Tax for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Total</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.total ?? 0}
                                        type='number'
                                        name='total'
                                        readOnly
                                        placeholder={`Total Price for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Reserve</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.reserve || null}
                                        type='number'
                                        name='reserve'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`Reserve for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    ></input>
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]?.reserve
                                                ? String(activityData?.price[priceindex]?.reserve)
                                                : ''
                                        }
                                        min={2}
                                        limit={7}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Higher Price</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.higherPrice || null}
                                        type='number'
                                        name='higherPrice'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`higherPrice Price for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    ></input>
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]?.higherPrice
                                                ? String(activityData?.price[priceindex].higherPrice)
                                                : ''
                                        }
                                        min={2}
                                        limit={7}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Discount Per Price</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.discountPer || null}
                                        type='number'
                                        name='discountPer'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`higherPrice Price for activity ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]?.discountPer
                                                ? String(activityData.price[priceindex].discountPer)
                                                : ''
                                        }
                                        min={2}
                                        limit={7}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>Name</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.name || ''}
                                        type='text'
                                        name='name'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`Name for price ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]?.name
                                                ? String(activityData.price[priceindex].name)
                                                : ''
                                        }
                                        min={3}
                                        limit={50}
                                    />
                                </div>
                            </div>
                            <div className={styles.priceInDiv}>
                                <label className={styles.priceLabel}>No of Peoples</label>
                                <div className={styles.priceInputDiv}>
                                    <input
                                        value={activityData?.price[priceindex]?.count || ''}
                                        type='number'
                                        name='count'
                                        onChange={(e) => handlePrice(e, priceindex)}
                                        placeholder={`Number of people for this price ${priceindex + 1} `}
                                        className={styles.priceInput}
                                    />
                                    <CharCount
                                        string={
                                            activityData?.price[priceindex]?.count
                                                ? String(activityData.price[priceindex].count)
                                                : ''
                                        }
                                        min={1}
                                        limit={2}
                                    />
                                </div>
                            </div>
                            <p className={'tagsNoteP'}>
                                Note: Type each point in new(press enter) line (each next point should come in new
                                line). Don't number the points as it will be numbered automatically on the user end
                            </p>
                            <div className='textareaDiv'>
                                <label className={styles.priceLabel}>Terms</label>
                                <textarea
                                    name='terms'
                                    id='terms'
                                    value={activityData?.price?.[priceindex]?.terms}
                                    onChange={(e) => handlePrice(e, priceindex)}
                                    className='textareaInput'
                                    placeholder='Terms and conditions of price'
                                />
                                <CharCount
                                    string={
                                        activityData?.price[priceindex]?.terms
                                            ? String(activityData.price[priceindex].terms)
                                            : ''
                                    }
                                    min={10}
                                    limit={1500}
                                />
                            </div>
                            <GuidInstallments
                                guidData={activityData}
                                setGuidData={setActivityData}
                                index={priceindex}
                            />
                        </div>
                    ))}
                <div className={`alignButtons ${styles.priceBtn}`}>
                    <button type='button' onClick={handleAddPrice} className={styles.priceAddBtn}>
                        Add Price
                    </button>
                    <button
                        type='button'
                        onClick={handleDeletePrice}
                        className={styles.priceDelBtn}
                        disabled={priceCount <= 1}
                    >
                        Delete Price
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ActivityPrice;
